import request from './axiosClient';
import { AxiosResponse } from 'axios';
const URL_SETTINGS_SHOP_CUSTOM = 'v2/settings-shop-custom-public';
const URL_SERVICES = 'services-public';
const URL_CALL_SERVICES = '/call-services-public';

export function getSettingsShopCustomAPI(params: {
  shop_id: number;
  bill_id: number | string;
  appName: string;
}): Promise<AxiosResponse<any>> {
  return request({
    url: URL_SETTINGS_SHOP_CUSTOM,
    method: 'get',
    params,
  });
}
export function getServicesAPI(params: {
  shop_id: number;
  appName: string;
}): Promise<AxiosResponse<any>> {
  return request({
    url: URL_SERVICES,
    method: 'get',
    params,
  });
}
export function callStaffServicesAPI(
  token: string,
  data: any,
  appName: string
): Promise<AxiosResponse<any>> {
  return request({
    url: URL_CALL_SERVICES,
    method: 'post',
    data,
    token,
    params: {
      appName,
    },
  });
}
// show_set_menu:
// disable_app
